"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Film, Gamepad2, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EntertainmentVerticals() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222298" id="most-popular-tools" className="bg-background text-foreground relative overflow-hidden py-24 px-6 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-20">
        <div className="h-[500px] w-[500px] rounded-full bg-primary/10 blur-[120px]" />
        <div className="h-[400px] w-[400px] rounded-full bg-chart-2/10 blur-[100px]" />
      </div>

      <div ref={ref} className={`mx-auto max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mb-16 flex flex-col items-center text-center">
          <h2 className="font-default text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
            Most Popular <span className="text-primary">Calculators</span>
          </h2>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground font-default">
            Our most frequently used precision tools for finance, math, and health. 
            Fast, accurate, and ready for your data.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          {}
          <Link to="/HomePage" className="group relative flex h-[500px] w-full flex-col justify-end overflow-hidden rounded-3xl border border-border bg-card p-8 transition-all duration-700 hover:-translate-y-4 hover:border-primary/50 hover:shadow-xl hover:shadow-primary/10 sm:h-[600px]">
            {}
            <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600149/img/finance_calculator_interface.png')] bg-cover bg-center opacity-10 mix-blend-multiply transition-all duration-700 group-hover:scale-110 group-hover:opacity-20 group-hover:blur-sm" />

            {}
            <div className="absolute inset-0 z-10 bg-gradient-to-t from-background via-background/60 to-transparent" />

            {}
            <div className="absolute -left-4 top-8 z-10 select-none font-default text-8xl font-black tracking-tighter text-primary/5 transition-colors duration-700 group-hover:text-primary/10 sm:text-9xl">
              MATH
            </div>

            {}
            <div className="relative z-20 flex flex-col gap-4 transition-transform duration-500 group-hover:translate-x-2">
              <div className="flex items-center gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary backdrop-blur-md transition-colors duration-700 group-hover:bg-primary group-hover:text-primary-foreground">
                  <Film className="h-7 w-7" />
                </div>
                <h3 className="font-default text-4xl font-bold text-foreground sm:text-5xl">
                  Finance Suite
                </h3>
              </div>
              <p className="max-w-md text-lg text-muted-foreground font-default">
                Calculate mortgage rates, loan repayments, and compound interest with professional-grade accuracy.
              </p>
              <div className="mt-4 flex items-center font-default text-lg font-semibold text-primary transition-colors duration-700 group-hover:text-chart-2">
                Launch Tool <ArrowRight className="ml-2 h-6 w-6 transition-transform duration-500 group-hover:translate-x-2" />
              </div>
            </div>
          </Link>

          {}
          <Link to="/HomePage" className="group relative flex h-[500px] w-full flex-col justify-end overflow-hidden rounded-3xl border border-border bg-card p-8 transition-all duration-700 hover:-translate-y-4 hover:border-chart-2/50 hover:shadow-xl hover:shadow-chart-2/10 sm:h-[600px]">
            {}
            <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600149/img/health_metrics_dashboard.png')] bg-cover bg-center opacity-10 mix-blend-multiply transition-all duration-700 group-hover:scale-110 group-hover:opacity-20 group-hover:blur-sm" />

            {}
            <div className="absolute inset-0 z-10 bg-gradient-to-t from-background via-background/60 to-transparent" />

            {}
            <div className="absolute -right-4 top-8 z-10 select-none font-default text-8xl font-black tracking-tighter text-chart-2/5 transition-colors duration-700 group-hover:text-chart-2/10 sm:text-9xl">
              BODY
            </div>

            {}
            <div className="relative z-20 flex flex-col gap-4 transition-transform duration-500 group-hover:translate-x-2">
              <div className="flex items-center gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-chart-2/10 text-chart-2 backdrop-blur-md transition-colors duration-700 group-hover:bg-chart-2 group-hover:text-primary-foreground">
                  <Gamepad2 className="h-7 w-7" />
                </div>
                <h3 className="font-default text-4xl font-bold text-foreground sm:text-5xl">
                  Health Metrics
                </h3>
              </div>
              <p className="max-w-md text-lg text-muted-foreground font-default">
                Track your BMI, daily caloric needs, and fitness progress using our scientifically-backed algorithms.
              </p>
              <div className="mt-4 flex items-center font-default text-lg font-semibold text-chart-2 transition-colors duration-700 group-hover:text-primary">
                Launch Tool <ArrowRight className="ml-2 h-6 w-6 transition-transform duration-500 group-hover:translate-x-2" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>;
}